import { render, staticRenderFns } from "./NoneOfTheAbove.vue?vue&type=template&id=0824d5bd&lang=pug"
import script from "./NoneOfTheAbove.vue?vue&type=script&lang=ts"
export * from "./NoneOfTheAbove.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports